import { FilterType } from "@studyportals/omnisearch-interfaces";
import { FilterMapper } from "@app/routing/mappers/FilterMapper";
import { AttendanceFilterValue } from "@studyportals/search-api-interface";
import {IExtendedWithPortalTypeFilterValue} from "@app/routing/mappers/IExtendedWithPortalTypeFilterValue";
import { PortalType } from "@studyportals/domain-client";

export class AttendanceFilterMapper extends FilterMapper {
	public filterType: FilterType = FilterType.ATTENDANCE;
	public isMultiSelect = true;
	private static instance: AttendanceFilterMapper;

	public static getInstance(): AttendanceFilterMapper {
		if (!AttendanceFilterMapper.instance) {
			AttendanceFilterMapper.instance = new AttendanceFilterMapper();
		}
		return AttendanceFilterMapper.instance;
	}

	private constructor() {
		super();
	}

	protected values: IExtendedWithPortalTypeFilterValue[] = [
		{ id: AttendanceFilterValue.FACE_2_FACE, virtualPath: 'on-campus', name: 'On Campus', portalTypes: [PortalType.MASTER, PortalType.BACHELOR, PortalType.PHD, PortalType.SHORT], isNotIndexable: true },
		{ id: AttendanceFilterValue.ONLINE, virtualPath: 'online', name: 'Online', implicitForPortalTypes: [PortalType.DISTANCE_LEARNING] },
		{ id: AttendanceFilterValue.BLENDED, virtualPath: 'blended', name: 'Blended' },
	];
}

